import React from 'react';
import { Box } from '@mui/material';
import { HeaderMenu } from '../types';
import HeaderMainMenu from './HeaderMainMenu';
import HeaderSignUpMenu from './HeaderSignUpMenu';

const MENU: HeaderMenu = [
	{
		path: '/',
		label: 'Home',
	},
	{
		path: '/forum',
		label: 'Forum',
	},
	{
		path: '/providers',
		label: 'Solution Providers',
	},
	{
		path: '/networking',
		label: 'Networking',
	},
	{
		path: '/community',
		label: 'Community',
	},
	{
		path: '/events',
		label: 'Events',
	},
	{
		path: '/job-postings',
		label: 'Job Postings',
	},
];
export default function PublicMenu() {
	return (
		<>
			<Box mr={2}>
				<HeaderMainMenu items={MENU} />
			</Box>
			<HeaderSignUpMenu />
		</>
	);
}
